import styled from 'styled-components';
import { colors, medias } from 'assets/styled/tokens';

export const StyledRadioButton = styled.button`
  background: #fff;
  color: #000000;
  border: 1px solid ${({ isActive }) => (isActive ? colors.primary : '#e8e1de')};
  border-radius: 4px;
  padding: 4px 8px;

  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
  transition: all 0.2s ease;
  font-family: Roboto;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.3px;
  margin-right: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 32px;
  max-width: ${props => props.width};
  @media (min-width: ${medias.desktopSm}) {
    width: auto;
    margin-right: 16px;
    font-size: 16px;
  }
  &:hover {
    background: ${({ isActive, disabled }) => (!isActive && !disabled ? colors.pampas : null)};
  }
  svg {
    margin-right: 10px;
  }
`;
